/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".loader-img[_ngcontent-%COMP%]{width:10%;position:absolute;left:45%;top:35%;z-index:1000}#overlay[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.7);z-index:100}.router-data[_ngcontent-%COMP%]{background-color:#f7f7f7}.menus[_ngcontent-%COMP%]{padding-right:0}.main-div[_ngcontent-%COMP%]{padding:0;margin:0}"];
export { styles as styles };
